<div class="container-scroller">
  <app-spinner *ngIf="isLoading"></app-spinner>
  <app-spinner style="display: none;" id="loaderId"></app-spinner>
  <app-navbar *ngIf="showNavbar"></app-navbar>
  <app-header *ngIf="showPublicHeader"></app-header>
  <div class="container-fluid page-body-wrapper">
    <app-settings-panel *ngIf="showSettings"></app-settings-panel>
    <app-sidebar *ngIf="showSidebar"></app-sidebar>
    <div class="main-panel" [ngClass]="{ 'main-panel-only' : !showSidebar }">
      <div class="content-wrapper" [ngClass]="{ 'margin-top-content' : showPublicHeader === true }">
        <div contentAnimate class="h-100">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-footer *ngIf="showFooter"></app-footer>
      <app-public-footer *ngIf="showPublicFooter"></app-public-footer>

    </div>

  </div>

</div>


<audio #newNotificationSound id="newNotificationSound" style="display: none;"
  src="../../../assets/sounds/newNotification.mp3" [autoplay]="false"></audio>
